// Mock data for POSTAÍ Coming Soon page

export const heroData = {
  title: "POSTAÍ",
  subtitle: "Seu social media virtual está chegando",
  description: "Pare de sofrer com criação de conteúdo e crescimento orgânico no Instagram. A revolução da produtividade para criadores de conteúdo.",
  launchDate: new Date('2026-01-15T00:00:00'),
  logoUrl: "https://customer-assets.emergentagent.com/job_e7d2c8af-0408-4ea0-8a8c-154f63bf4f4e/artifacts/wsoilgkg_OFICIALPOSTAI.png"
};

export const featuresData = [
  {
    id: 1,
    title: "Criação de Conteúdo",
    description: "Crie posts incríveis em segundos com nossa IA avançada",
    icon: "Sparkles"
  },
  {
    id: 2,
    title: "Crescimento Orgânico",
    description: "Estratégias inteligentes para aumentar seu alcance naturalmente",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Agendamento",
    description: "Programe seus posts e libere seu tempo para criar",
    icon: "Calendar"
  },
  {
    id: 4,
    title: "Analytics",
    description: "Entenda seu público com métricas detalhadas",
    icon: "BarChart3"
  }
];

export const contactData = {
  email: "contato@meupostai.com.br",
  privacyEmail: "privacidade@meupostai.com.br"
};
